import axios from 'axios'

const PAGE_NUM = 'PAGE_NUM'
const initState = {
	'pageNum':1
}

export function message(state=initState, action){
	switch(action.type){
		case PAGE_NUM:
			return {
				'pageNum':action.inum
			}
		
		default:
			return state
	}
}

export function pagingFn(num){

	return { type:PAGE_NUM,inum:num}
}




// WEBPACK FOOTER //
// ./src/redux/message.redux.js